/* Gellies · Avis : filtres, « Voir plus », barre collante mobile, suivi des clics. */
(() => {
  const init = (root) => {
    if (root.dataset.grvReady) return;
    root.dataset.grvReady = 'true';

    const list = root.querySelector('[data-grv-list]');
    const cards = Array.from(root.querySelectorAll('[data-grv-card]'));
    const inlineCta = root.querySelector('[data-grv-inline-cta]');
    const filters = root.querySelector('[data-grv-filters]');
    const filterButtons = filters ? Array.from(filters.querySelectorAll('[data-grv-filter]')) : [];
    const more = root.querySelector('[data-grv-more]');
    const moreButton = root.querySelector('[data-grv-more-button]');
    const initial = parseInt(list?.dataset.grvInitial, 10) || cards.length;

    let filter = 'all';
    let expanded = cards.length <= initial;

    const render = () => {
      let visible = 0;
      cards.forEach((card) => {
        const matches = filter === 'all' || card.dataset.species === filter;
        const withinLimit = expanded || filter !== 'all' || visible < initial;
        const show = matches && withinLimit;
        card.hidden = !show;
        if (matches) visible += 1;
      });
      if (inlineCta) inlineCta.hidden = filter !== 'all';
      if (more) more.hidden = expanded || filter !== 'all';
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        filter = button.dataset.grvFilter;
        filterButtons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        render();
      });
    });

    moreButton?.addEventListener('click', () => {
      const firstHidden = cards.find((card) => card.hidden);
      expanded = true;
      render();
      firstHidden?.querySelector('h3')?.setAttribute('tabindex', '-1');
      firstHidden?.querySelector('h3')?.focus({ preventScroll: true });
    });

    if (filters && filterButtons.length > 1) filters.hidden = false;
    render();

    const comparison = root.querySelector('[data-grv-compare]');
    if (comparison && 'IntersectionObserver' in window) {
      const comparisonObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        comparison.classList.add('is-revealed');
        observer.disconnect();
      }, { threshold: 0.25 });
      comparisonObserver.observe(comparison);
    }

    /* Barre collante : visible quand le choix chat/chien du hero est hors écran,
       masquée au niveau du choix produit et du CTA final. */
    const sticky = root.querySelector('[data-grv-sticky]');
    const heroCta = root.querySelector('[data-grv-hero-cta]');
    const blockers = [root.querySelector('[data-grv-choose]'), root.querySelector('[data-grv-final]')].filter(Boolean);

    if (sticky && heroCta && 'IntersectionObserver' in window) {
      const state = new Map();
      const update = () => {
        const heroVisible = state.get(heroCta);
        const heroAbove = heroCta.getBoundingClientRect().bottom < 0;
        const blocked = blockers.some((el) => state.get(el));
        const show = !heroVisible && heroAbove && !blocked;
        sticky.classList.toggle('is-visible', show);
        sticky.toggleAttribute('inert', !show);
        sticky.setAttribute('aria-hidden', String(!show));
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => state.set(entry.target, entry.isIntersecting));
        update();
      });
      [heroCta, ...blockers].forEach((el) => observer.observe(el));
    }

    /* Suivi léger : événement personnalisé + dataLayer si présent. */
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-grv-track]');
      if (!link) return;
      const detail = { location: link.dataset.grvTrack, href: link.getAttribute('href') };
      window.dataLayer?.push({ event: 'gellies_reviews_cta', ...detail });
      document.dispatchEvent(new CustomEvent('gellies:reviews-cta', { detail }));
    });
  };

  const boot = () => document.querySelectorAll('[data-grv]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
